var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPwPalau(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_22340)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.666 0H-9.67461V45H69.666V0Z",
    fill: "#4AADD6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9473 21.7591C21.9011 23.3881 22.1964 25.0094 22.8156 26.5273C23.4349 28.0452 24.3657 29.4289 25.5529 30.5967C26.7401 31.7645 28.1597 32.6927 29.7279 33.3265C31.296 33.9603 32.981 34.2868 34.6832 34.2868C36.3854 34.2868 38.0704 33.9603 39.6385 33.3265C41.2067 32.6927 42.6263 31.7645 43.8135 30.5967C45.0008 29.4289 45.9315 28.0452 46.5508 26.5273C47.17 25.0094 47.4653 23.3881 47.4191 21.7591C47.4653 20.1302 47.17 18.5089 46.5508 16.991C45.9315 15.4731 45.0008 14.0894 43.8135 12.9216C42.6263 11.7538 41.2067 10.8256 39.6385 10.1918C38.0704 9.55799 36.3854 9.23145 34.6832 9.23145C32.981 9.23145 31.296 9.55799 29.7279 10.1918C28.1597 10.8256 26.7401 11.7538 25.5529 12.9216C24.3657 14.0894 23.4349 15.4731 22.8156 16.991C22.1964 18.5089 21.9011 20.1302 21.9473 21.7591Z",
    fill: "#FFDE00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_22340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwPalau);
export default __webpack_public_path__ + "static/media/pw Palau.f98556fae3bfb95ac8d938b7b8ae518a.svg";
export { ForwardRef as ReactComponent };